import { useMemo, useState } from "react"
import { DataTypeList } from "../../../../../features/data-types"
import { Column, Data, FieldType, FieldValue, O, PanelWrapper, SpinnerDiv, TotalAmountSection } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { Transaction } from "../../../state/types"
import { DataType } from "../../../../../tables"
import { TransactionFilters } from "./transactionFilters"
import { TransactionSource } from "../transaction-source/transactionSource"
import { TransactionDestination } from "../transaction-destination/transactionDestination"
import { transactionHelpers } from "../../../hooks/transactionHooks"

export const TransactionList = () => {
    const [transactions, setTransactions] = useState<Transaction[]>([])
    const [cashFundId, setCashFundId] = useState<O<string>>()
    const [asyncDataLoaded, setAsyncDataLoaded] = useState(false)

    const { isOutcome } = transactionHelpers

    const rows: Data[] = useMemo(() => transactions.map(transaction => ({
        ...transaction,
        sourceId: transaction.id,
        destinationId: transaction.id,
        amount: isOutcome(transaction, cashFundId) ? -transaction.amount : transaction.amount
    })), [transactions, cashFundId])

    const setRowsState = (transactions: Transaction[]) => {
        setTransactions(transactions)
        setAsyncDataLoaded(true)
    }

    const totalAmount = useMemo(() => rows.reduce((acc, row) => acc + (row.amount as number), 0), [rows])

    const columns: Column[] = [
        {
            name: 'date',
            type: FieldType.DATE,
            label: 'Fecha'
        },
        {
            name: 'sourceId',
            type: FieldType.TABLE,
            label: 'Origen',
            sortable: false,
            render: (value?: FieldValue) => {
                const transaction = transactions.find(transaction => transaction.id === value)!
                return <TransactionSource transaction={transaction} />
            }
        },
        {
            name: 'amount',
            type: FieldType.PRICE,
            label: 'Monto'
        },
        {
            name: 'destinationId',
            type: FieldType.TABLE,
            label: 'Destino',
            sortable: false,
            render: (value?: FieldValue) => {
                const transaction = transactions.find(transaction => transaction.id === value)!
                return <TransactionDestination transaction={transaction} />
            }
        }
    ]

    const onSearchStart = () => setAsyncDataLoaded(false)

    const onSearchDone = (dataTypes: DataType[]) => {
        setRowsState(dataTypes as Transaction[])
    }

    const renderAsync = (element: JSX.Element) => asyncDataLoaded ? element : <SpinnerDiv />

    return (
        <PanelWrapper title="Transacciones" wide titleRight={<BookmarkButton routePath={RoutePath.TRANSACTIONS} />}>
            <TransactionFilters
                onChangeCashFund={setCashFundId}
                onSearchStart={onSearchStart}
                onSearchDone={onSearchDone}
            />
            {cashFundId ? (
                <TotalAmountSection
                    totalAmount={totalAmount}
                    loaded={asyncDataLoaded}
                    label="Total Transacciones"
                />
            ) : <></>}
            {renderAsync(
                <DataTypeList
                    columns={columns}
                    rows={rows}
                    readOnly
                />
            )}
        </PanelWrapper>
    )
}
